import React, { useState } from "react";

function Settings() {
  const [settings, setSettings] = useState({
    companyName: "My Company Pvt Ltd",
    defaultCurrency: "INR",
    timeZone: "IST (India Standard Time)",
    dateFormat: "DD/MM/YYYY",
    language: "English",
    regionalLanguage: "Hindi",
    gstNumber: "",
    panNumber: "",
    aadhaarNumber: "",
    enableUPI: true,
    preferredBank: "HDFC Bank",
    holidayRegion: "India - National",
    emailNotifications: true,
    smsNotifications: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setSettings((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSave = () => {
    alert("Settings updated successfully!");
  };

  return (
    <div className="max-w-3xl mx-auto mt-10 p-6 bg-white shadow-md rounded-lg">
      <h2 className="text-2xl font-bold mb-4">Settings</h2>

      {/* General Settings */}
      <div className="space-y-4 border-b pb-4">
        <h3 className="text-lg font-semibold">General Settings</h3>
        <label className="block text-gray-700 font-medium">Company Name</label>
        <input type="text" name="companyName" value={settings.companyName} onChange={handleChange} className="w-full px-4 py-2 border rounded-md"/>

        <label className="block text-gray-700 font-medium">Currency</label>
        <select name="defaultCurrency" value={settings.defaultCurrency} onChange={handleChange} className="w-full px-4 py-2 border rounded-md">
          <option>INR</option><option>USD</option><option>EUR</option>
        </select>

        <label className="block text-gray-700 font-medium">Time Zone</label>
        <select name="timeZone" value={settings.timeZone} onChange={handleChange} className="w-full px-4 py-2 border rounded-md">
          <option>IST (India Standard Time)</option><option>GMT</option><option>PST</option>
        </select>

        <label className="block text-gray-700 font-medium">Date Format</label>
        <select name="dateFormat" value={settings.dateFormat} onChange={handleChange} className="w-full px-4 py-2 border rounded-md">
          <option>DD/MM/YYYY</option><option>MM/DD/YYYY</option>
        </select>

        <label className="block text-gray-700 font-medium">Preferred Language</label>
        <select name="regionalLanguage" value={settings.regionalLanguage} onChange={handleChange} className="w-full px-4 py-2 border rounded-md">
          <option>Hindi</option><option>Tamil</option><option>Telugu</option><option>Kannada</option><option>Malayalam</option><option>English</option>
        </select>
      </div>

      {/* Compliance & Tax Settings */}
      <div className="space-y-4 border-b pb-4 mt-4">
        <h3 className="text-lg font-semibold">Compliance & Taxation</h3>
        <label className="block text-gray-700 font-medium">GST Number</label>
        <input type="text" name="gstNumber" value={settings.gstNumber} onChange={handleChange} className="w-full px-4 py-2 border rounded-md" placeholder="Ex: 22AAAAA0000A1Z5"/>

        <label className="block text-gray-700 font-medium">PAN Number</label>
        <input type="text" name="panNumber" value={settings.panNumber} onChange={handleChange} className="w-full px-4 py-2 border rounded-md" placeholder="Ex: ABCDE1234F"/>

        <label className="block text-gray-700 font-medium">Aadhaar Number</label>
        <input type="text" name="aadhaarNumber" value={settings.aadhaarNumber} onChange={handleChange} className="w-full px-4 py-2 border rounded-md" placeholder="Ex: 1234 5678 9012"/>
      </div>

      {/* Payment & Banking Settings */}
      <div className="space-y-4 border-b pb-4 mt-4">
        <h3 className="text-lg font-semibold">Payment & Banking</h3>
        <label className="flex items-center space-x-3">
          <input type="checkbox" name="enableUPI" checked={settings.enableUPI} onChange={handleChange} className="w-5 h-5"/>
          <span className="text-gray-700">Enable UPI Payments</span>
        </label>

        <label className="block text-gray-700 font-medium">Preferred Bank</label>
        <select name="preferredBank" value={settings.preferredBank} onChange={handleChange} className="w-full px-4 py-2 border rounded-md">
          <option>HDFC Bank</option><option>ICICI Bank</option><option>State Bank of India</option><option>Axis Bank</option><option>Kotak Bank</option>
        </select>
      </div>

      {/* Holiday & Regional Settings */}
      <div className="space-y-4 border-b pb-4 mt-4">
        <h3 className="text-lg font-semibold">Holiday & Calendar</h3>
        <label className="block text-gray-700 font-medium">Holiday Calendar</label>
        <select name="holidayRegion" value={settings.holidayRegion} onChange={handleChange} className="w-full px-4 py-2 border rounded-md">
          <option>India - National</option><option>Maharashtra</option><option>Tamil Nadu</option><option>Karnataka</option><option>West Bengal</option>
        </select>
      </div>

      {/* Notification Settings */}
      <div className="space-y-4 border-b pb-4 mt-4">
        <h3 className="text-lg font-semibold">Notifications</h3>
        <label className="flex items-center space-x-3">
          <input type="checkbox" name="emailNotifications" checked={settings.emailNotifications} onChange={handleChange} className="w-5 h-5"/>
          <span className="text-gray-700">Email Notifications</span>
        </label>

        <label className="flex items-center space-x-3">
          <input type="checkbox" name="smsNotifications" checked={settings.smsNotifications} onChange={handleChange} className="w-5 h-5"/>
          <span className="text-gray-700">SMS Notifications</span>
        </label>
      </div>

      {/* Save Button */}
      <button onClick={handleSave} className="mt-4 w-full py-2 bg-blue-600 text-white rounded-md hover:bg-blue-500">
        Save Settings
      </button>
    </div>
  );
}

export default Settings;